import { Helmet } from "react-helmet-async";
import bg1 from '../assets/images/backgrounds/rentic_bg_element1.svg';
import bg3 from '../assets/images/backgrounds/rentic_bg_element3.svg';
import { SpinnerContainer } from "../components/common/SpinnerContainer";
import { useState } from "react";
import { PrimaryButton } from "../components/buttons/PrimaryButton";
import { Label } from "../components/form/Label";
import { Input } from "../components/form/Input";
import { resetPasswordWithEmail } from "../api/requests/auth";
import CheckIcon from '@mui/icons-material/Check';

export const ResetPwdEmailPage = () => {
    const [loadingSendPwdReset, setLoadingSendPwdReset] = useState(false);

    const [email, setEmail] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [emailValid, setEmailValid] = useState(false);
    const [pwdResetSuccess, setPwdResetSuccess] = useState(false);
    const [error, setError] = useState(false);

    function isValidEmail(email: string): boolean {
        const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    const handleEmailChange = (val: string) => {
        setEmail(val);
        setEmailValid(isValidEmail(val));
    }

    const submitChangePwd = async () => {
        setIsSubmitted(true);
        if (!emailValid) {
            return;
        }
        setLoadingSendPwdReset(true);

        try {
            const res = await resetPasswordWithEmail(email);
            setLoadingSendPwdReset(false);
            setPwdResetSuccess(true);
        } catch (e) {
            setError(true);
            setLoadingSendPwdReset(false);
        }
    }

    return (
        <div className="w-full h-full flex justify-center items-center">

            <Helmet>
                <title>Rentic - Muuda parooli</title>
                <meta name="keywords" content="rentic, alusta rentimist, loo Renticu konto, Renticu kasutaja, eseme rent" />
                <meta property="og:title" content="Rentic - Parooli taastamine" />
                <meta property="og:description" content="Muuda oma parool Renticu rendiplatformil." />
                <meta property="og:image" content="/logo512.png" />
                <meta property="og:url" content="https://rentic.ee/reset_password_email" />
            </Helmet>

            <img className="absolute top-0 left-0 h-[90%] opacity-35 w-auto pointer-events-none" src={bg1} alt="" />
            <img className="absolute top-0 right-0 h-[50%] opacity-0 lg:opacity-25 object-contain object-top w-auto pointer-events-none" src={bg3} alt="" />
            <div className="mt-[60px] w-full flex justify-center pb-10">
            <div>
                {
                    pwdResetSuccess ?
                    <div className="w-full md:w-[400px] space-y-2 h-fit shadow-main z-10 bg-white px-8 py-7 rounded-xl">
                        <CheckIcon style={{width: "30px", height: "30px"}} className="text-green-500"/>
                        <div>Kui antud e-posti aadressile <b>{email}</b> vastab meie platvormil konto, siis saatsime teile kinnituslingi.</div>
                    </div>
                    :
                    <SpinnerContainer show={loadingSendPwdReset}>
                    <div className="w-full md:w-[400px] space-y-2 h-fit shadow-main z-10 bg-white px-8 py-7 rounded-xl">
                        <h2>Parooli taastamine</h2>
                        <div className="text-left">Sisestage alla konto e-posti aadress millele soovite parooli taastada.</div>
                            <form onSubmit={(e) => { e.preventDefault(); submitChangePwd(); }} className="space-y-2 flex flex-col gap-2">
                                <div>
                                    <div className="flex row align-middle">
                                        <Label value="E-posti aadress" />
                                    </div>
                                    <Input value={email} onChange={(e) => handleEmailChange(e)} placeHolder="Kirjutage siia" name="email" invalid={!emailValid && isSubmitted} errorText="E-posti aadress on vigane"></Input>
                                </div>
                                <div className="pt-4">
                                    <PrimaryButton title='Saada' onClick={() => {}} />
                                </div>
                            </form>
                            {error &&
                            <div className="text-red-500">Parooli taastamine ebaõnnestus</div>
                            }
                    </div>
                    </SpinnerContainer>
                }
            </div>
            </div>
        </div>
    )
}